import { formatRangeValues } from 'lib/reportUtils';
import { isDate } from '@hone-automation/common';
import { Amounts } from './types';

export { isDate, isDateBetween } from '@hone-automation/common';

export const isLiveReport = (report: NestedHoneReport): number => {
  return report.dates.findIndex((date: any) => {
    if (date.end && date.end.startsWith('2')) {
      return new Date(date.end).getTime() > new Date().getTime();
    }
    return false;
  });
};

export const reportRange = (report: NestedHoneReport): { start: string; end: string; range: string } => {
  const start = report.dates[0]?.start ?? '';
  const end = report.dates[report.dates.length - 1]?.end ?? '';
  const range = isDate(start)
    ? formatRangeValues(start && end ? `${start} - ${end}` : start, 'KS')
    : start || 'Default Range';
  return { start, end, range };
};

export const buildTitle = (
  report: NestedHoneReport,
  datesRange?: { start: string; end: string; range: string }
): string => {
  return [
    report.type + ` (${report.timeframe})`,
    datesRange && datesRange.range !== datesRange.start
      ? datesRange.range
      : new Date().toLocaleString('en-US', { month: 'short', year: '2-digit' }),
  ].join(' - ');
};

// Utility function to get the data serie for the amounts column
export const series = (data: any[], property: string): any[] =>
  data.map(item => {
    const value = item[property];
    return Array.isArray(value) ? value.length : value;
  });

export const generateFilteredId = (section: string, title: string): string => {
  return section === ''
    ? 'row_' +
        title
          .toLowerCase()
          .replace(/[^\w\s]/gi, '')
          .replace(/\s+/g, '')
          .slice(0, 20)
    : section;
};

export const findDataElementByTitle = (columnData: Amounts[], title: string) => {
  if (!title) return null;
  const filteredTitle = title.replace(/^\([^)]*\)\s*/, '').trim();
  return columnData.find(element => element.title === filteredTitle || element.refTitle === filteredTitle);
};

export const logger = {
  msg: (msg: string, data?: any) => {
    if (window.location.hostname === 'localhost') {
      // eslint-disable-next-line no-console
      console.log(`[LOG] ${msg}`, data || '');
    } else {
      console.warn(`[LOG] ${msg}`, data || '');
    }
  },
  error: (msg: string, data?: any) => {
    if (window.location.hostname === 'localhost') {
      // eslint-disable-next-line no-console
      console.log(`[ERROR] ${msg}`, data || '');
    } else {
      console.warn(`[ERROR] ${msg}`, data || '');
    }
  },
};
